import { render, staticRenderFns } from "./registerStep.vue?vue&type=template&id=02ca28b7&scoped=true&"
import script from "./registerStep.vue?vue&type=script&lang=js&"
export * from "./registerStep.vue?vue&type=script&lang=js&"
import style0 from "./registerStep.vue?vue&type=style&index=0&id=02ca28b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ca28b7",
  null
  
)

export default component.exports